import LegalLayout from "./LegalLayout";
import Footer from "../components/Footer";
import Navigation from "../components/Navigation";

export default function Datenschutz() {
  return (
    <>
      <Navigation />
      <LegalLayout
        title="Datenschutzerklärung"
        subtitle="Informationen gemäß Art. 13 DSGVO"
        testid="datenschutz-page"
      >
        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            1. Verantwortlicher
          </h2>
          <p>
            Verantwortlich für die Datenverarbeitung auf dieser Website ist:
            <br />
            <br />
            H. Dogan &amp; N. Noury<br />
            Hair &amp; Beauty Nava<br />
            Hainer Weg 146<br />
            60599 Frankfurt am Main<br />
            Telefon: +49 1575 9436804<br />
            E-Mail:{" "}
            <a href="mailto:hairbeautynava@gmail.com" className="text-white hover:text-[#D4AF37]">
              hairbeautynava@gmail.com
            </a>
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            2. Allgemeines zur Datenverarbeitung
          </h2>
          <p>
            Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich
            nur, soweit dies zur Bereitstellung einer funktionsfähigen Website
            sowie unserer Inhalte und Leistungen erforderlich ist. Die
            Verarbeitung personenbezogener Daten erfolgt regelmäßig nur nach
            Einwilligung des Nutzers oder wenn eine Rechtsgrundlage gem. Art. 6
            DSGVO eine Verarbeitung gestattet.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            3. Erhebung von Daten beim Besuch der Website
          </h2>
          <p>
            Beim Aufrufen unserer Website werden durch den Hosting-Anbieter
            automatisch Informationen in Server-Logfiles gespeichert, die Ihr
            Browser übermittelt: IP-Adresse, Datum und Uhrzeit des Zugriffs,
            Browsertyp, Betriebssystem, Referrer-URL.
          </p>
          <p className="mt-3">
            Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes
            Interesse). Die Daten werden zur Sicherstellung eines
            reibungslosen Verbindungsaufbaus und zur Systemsicherheit
            verarbeitet und nach kurzer Zeit gelöscht.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            4. Kontaktaufnahme
          </h2>
          <p>
            Wenn Sie uns per E-Mail oder Telefon kontaktieren, werden Ihre
            Angaben zwecks Bearbeitung der Anfrage und für den Fall von
            Anschlussfragen bei uns gespeichert. Rechtsgrundlage: Art. 6 Abs. 1
            lit. b DSGVO (Anbahnung/Erfüllung eines Vertrags) bzw. Art. 6 Abs. 1
            lit. f DSGVO (berechtigtes Interesse).
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            5. Online-Terminbuchung über Salonkee
          </h2>
          <p>
            Für die Online-Terminbuchung im Bereich Beauty nutzen wir den
            Dienst <strong className="text-white">Salonkee</strong> (Salonkee
            S.A., Luxemburg). Beim Klick auf den Buchungs-Button werden Sie auf
            die Plattform von Salonkee weitergeleitet. Dort gelten die
            Datenschutzbestimmungen von Salonkee:{" "}
            <a
              href="https://www.salonkee.de/de/datenschutzerklarung"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-[#D4AF37] underline"
            >
              salonkee.de/datenschutzerklarung
            </a>
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            6. Hosting &amp; Externe Inhalte
          </h2>
          <p>
            Diese Website wird bei einem externen Dienstleister gehostet. Die
            personenbezogenen Daten, die auf dieser Website erfasst werden,
            werden auf den Servern des Hosters gespeichert. Es kann sich hierbei
            v. a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten
            handeln.
          </p>
          <p className="mt-3">
            Wir binden Inhalte Dritter (z. B. Schriftarten von Google Fonts und
            Bilder von Unsplash) ein. Dabei wird zwangsläufig Ihre IP-Adresse an
            die Drittanbieter übermittelt. Rechtsgrundlage ist Art. 6 Abs. 1
            lit. f DSGVO.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            7. Cookies &amp; Analyse
          </h2>
          <p>
            Diese Website verwendet technisch notwendige Cookies, die für den
            Betrieb der Seite erforderlich sind. Sollten Analyse- oder
            Marketing-Cookies eingesetzt werden, geschieht dies nur nach Ihrer
            ausdrücklichen Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).
          </p>
          <p className="mt-3 text-white/55">
            [Hinweis: Falls ein Analyse-Tool eingebunden wird – z. B. PostHog
            oder Google Analytics – ergänzen Sie hier den Anbieter und die
            Zweckbestimmung.]
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            8. Ihre Rechte
          </h2>
          <p>
            Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie
            betreffenden personenbezogenen Daten:
          </p>
          <ul className="mt-3 space-y-1 list-disc list-inside marker:text-[#D4AF37]">
            <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
            <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
            <li>Recht auf Löschung (Art. 17 DSGVO)</li>
            <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
            <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
            <li>Recht auf Widerspruch (Art. 21 DSGVO)</li>
            <li>Recht auf Widerruf erteilter Einwilligungen (Art. 7 Abs. 3 DSGVO)</li>
          </ul>
          <p className="mt-3">
            Zur Ausübung Ihrer Rechte genügt eine formlose Nachricht an{" "}
            <a href="mailto:hairbeautynava@gmail.com" className="text-white hover:text-[#D4AF37]">
              hairbeautynava@gmail.com
            </a>
            .
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl text-[#D4AF37] mb-3">
            9. Beschwerderecht bei der Aufsichtsbehörde
          </h2>
          <p>
            Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu
            beschweren. Zuständig in Hessen:{" "}
            <strong className="text-white">
              Der Hessische Beauftragte für Datenschutz und Informationsfreiheit
            </strong>
            , Gustav-Stresemann-Ring 1, 65189 Wiesbaden.
          </p>
        </section>

        <p className="text-white/40 text-xs pt-8 border-t border-white/10">
          Stand: {new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" })}
        </p>
      </LegalLayout>
      <Footer />
    </>
  );
}
